import { render, staticRenderFns } from "./PostEventTitle.vue?vue&type=template&id=3598e13c"
import script from "./PostEventTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./PostEventTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports